import { render, staticRenderFns } from "./AdBox.vue?vue&type=template&id=9c1b0426&scoped=true&"
var script = {}
import style0 from "./AdBox.vue?vue&type=style&index=0&id=9c1b0426&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1b0426",
  null
  
)

export default component.exports